import extend from '@/utils/helpers/extend';

export default {
  namespaced: true,

  state: () => ({
    stores: [],
    storesIdHashMap: {},
    loading: false,
  }),

  getters: {
    stores: (state) => state.stores,
  },

  mutations: {
    setLoading: (state, value) => {
      state.loading = value;
    },
    setStores: (state, stores = []) => {
      state.stores = stores;
      state.storesIdHashMap = stores.reduce((acc, store) => {
        acc[store.id] = extend(store);
        return acc;
      }, {});
    },
  },

  actions: {
    loadStores({ commit }, { cityId, sort } = {}) {
      commit('setLoading', true);
      return this.$api.loadStores({ cityId, sort })
        .then((stores) => {
          commit('setStores', stores);
          return stores;
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => commit('setLoading', false));
    },
  },
};
